<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'authAccess',
      key: 'suid',
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        // {
        //   label: '账户类型',
        //   name: 'type',
        //   value: '',
        //   type: 'select',
        //   dropList: [],
        //   rules: [{ required: true, trigger: 'blur', type: 'number' }],
        // },
        { label: '姓名', name: 'name', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '手机号', name: 'user_mobile', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '登录密码', name: 'password', value: '', type: 'password', desc: '更新账户时，如不需要修改密码，请留空' },
        { label: '账号头像', name: 'head', value: '', type: 'image', desc: '建议图片宽高尺寸512*512像素及以上', rules: [{ required: true, trigger: 'blur' }] },
        { label: '权限信息', desc: '权限控制信息', type: 'header' },
        { label: '角色权限', name: 'group_ids', value: '', type: 'select', multiple: true, dropList: [], rules: [{ required: true, trigger: 'blur', type: 'array' }] },
        { label: '数据可见范围', desc: '控制数据可见范围', type: 'header' },
        // { label: '村组', name: 'shop_ids', value: '', type: 'select', multiple: true, dropList: [], rules: [{ required: false, trigger: 'blur', type: 'array' }] },
        { label: '备注', name: 'remark', value: '', type: 'textarea' },
        { label: '状态', name: 'status', value: 1, type: 'switch', trueValue: 1, falseValue: 0 },
      ],
      forms: {},
    }
  },
  async created() {
    let query = this.$route.query
    if (query.type) {
      this.forms.type = query.type
    }
    await this.loadItemsFieldDrop('auth_type', 'type')
    await this.loadItemsFieldDrop('auth_group', 'group_ids')
    //  this.getShopDrop()
  },
  methods: {
    initData() {
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res
          this.$forceUpdate()
          console.log('initData forms', this.forms)
        }
      })
    },
    //  getShopDrop() {
    //   let field = 'shop_ids'
    //   // let ll = await this.loadShopIds()
    //   // if (ll) {
    //   //   let dropList = []
    //   //   for (let index = 0; index < ll.length; index++) {
    //   //     const element = ll[index]
    //   //     let xx = {}
    //   //     xx.value = element.value
    //   //     xx.name = element.name
    //   //     xx.children = element.children || []
    //   //     dropList.push(xx)
    //   //   }
    //   //   for (let index = 0; index < this.items.length; index++) {
    //   //     const element = this.items[index]
    //   //     if (element && element.name == field && element.type == 'select') {
    //   //       this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
    //   //     }
    //   //   }
    //   //   console.log('dropList ' + field, dropList)
    //   // }
    //   let q = {};
    //   $utils.api.load(`HeadCategorynotPagelist`, q).then((res) => {
    //     console.log(res, "222222");
    //     if (res && res.data) {
    //       let ll = res.data;
    //       let dropList = [];
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index];
    //         let xx = {};
    //         xx.value = element.category_id;
    //         xx.name = element.name;
    //         xx.children = element.children || [];
    //         dropList.push(xx);
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index];
    //         if (element && element.name == field) {
    //         this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
    //           // this.items[index]["dropList"] = (
    //           //   element["dropList"] || []
    //           // ).concat(dropList);
    //         }
    //       }
    //       console.log("dropList category_id", dropList);
    //     }
    //   });
    // },
    handleSubmit() {
      if (!this.action) {
        return true
      }
      this.$refs.form.validate((valid) => {
        console.log('handleSubmit forms', valid, this.forms)
        if (valid) {
          this.forms.group_ids = (this.forms.group_ids || []).join(',')
          this.forms.shop_ids = (this.forms.shop_ids || []).join(',')
          $form.handleSubmit(this)
        }
      })
    },
  },
}
</script>
